import LiveController from './live';
import configuration from './configuration';

export default class MagnetoIntegration {
  constructor(Magneto, container, { playerOptions = {}, zappingOptions, liveOptions = {} } = {}) {
    /* We set the diffusion mode for zapping before the player initialization */
    if (playerOptions.zapping && !playerOptions?.diffusion?.mode) {
      Object.assign(playerOptions, {
        diffusion: {
          ...(playerOptions.diffusion ? playerOptions.diffusion : {}),
          mode: 'live_with_zapping'
        }
      });
    }

    this.playerOptions = MagnetoIntegration.setupChromecastOption(configuration, playerOptions);
    this.player = new Magneto(container, this.playerOptions);

    if (playerOptions.zapping && zappingOptions) {
      this.player.on('zappingClicked', (_, { id, name, showAd }) => {
        this.player.load({
          src: id,
          config: {
            intro: false,
            autostart: true,
            diffusion: { mode: 'live_from_zapping' },
            name,
            showAd,
            tracking: {
              pageProvenance: '',
              zoneProvenance: 'zappette_player',
              positionVignette: '',
              playProvenance: 'zapette'
            }
          }
        });
      });
    }

    this.liveCtrl = new LiveController(this.player, liveOptions);
    this.player.on('video_start', () => this.handleLive());
    this.player.on('error', () => this.liveCtrl.reset());
  }

  static setupChromecastOption(conf, playerOptions = {}) {
    return { chromecastReceiverId: conf.chromecast.chromecastReceiverId, ...playerOptions };
  }

  handleLive() {
    this.liveCtrl.reset();
    const { media } = this.player.store.getState();
    if (media.isLive) this.liveCtrl.start(media);
  }
}
